import { i18n } from '@/plugins/i18n'

export const pspList = {
    NOVIN: "novin",
    MELLAT: "mellat",
    SADAD: "sadad",
    PARSIAN: "parsian",
    PASARGAD: "pasargad",
    SAMAN: "saman",
    MASKAN: "maskan",
    SADERAT: "saderat",
}

export const pspLoopList = [
    {
        value: "novin",
        title: i18n.t('psp.novin')
    },
    {
        value: "mellat",
        title: i18n.t('psp.mellat')
    },
    {
        value: "sadad",
        title: i18n.t('psp.sadad')
    },
    {
        value: "parsian",
        title: i18n.t('psp.parsian')
    },
    {
        value: "pasargad",
        title: i18n.t('psp.pasargad')
    },
    {
        value: "saman",
        title: i18n.t('psp.saman')
    },
    {
        value: "maskan",
        title: i18n.t('psp.maskan')
    },
    {
        value: "saderat",
        title: i18n.t('psp.saderat')
    }
]

export const pspStr = {
    NOVIN: i18n.t('psp.novin'),
    MELLAT: i18n.t('psp.mellat'),
    SADAD: i18n.t('psp.sadad'),
    PARSIAN: i18n.t('psp.parsian'),
    PASARGAD: i18n.t('psp.pasargad'),
    SAMAN: i18n.t('psp.saman'),
    MASKAN: i18n.t('psp.maskan'),
    SADERAT:i18n.t('psp.saderat'),
    get(psp) {
        let psp_str = null;
        Object.keys(pspList).forEach(function (item) {
            if(pspList[item] === psp) {
                psp_str = pspStr[item]
            }
        })

        return psp_str
    }
}